import React, { useContext, useState, useCallback, useEffect } from 'react';
import classnames from 'classnames';
import { useOnScroll } from '../utils/hooks/useOnScroll';
import { PopupScrollableContext } from '../Popup/PopupScrollableContext';
import { SimpleBackToTop } from '../BackToTop';
import s from './ScrollableContent.scss';
var THROTTLE_TIMEOUT = 200;
var ScrollableContent = function (_a) {
    var wrapperClassName = _a.wrapperClassName, className = _a.className, children = _a.children, _b = _a.throttleTimeout, throttleTimeout = _b === void 0 ? THROTTLE_TIMEOUT : _b, onScrolled = _a.onScrolled, onNotScrollable = _a.onNotScrollable, _c = _a.hasBackToTop, hasBackToTop = _c === void 0 ? false : _c, backToTopClassName = _a.backToTopClassName, backToTopForcedTheme = _a.backToTopForcedTheme;
    var contentRef = React.useRef(null);
    var setScrollableContentRef = useContext(PopupScrollableContext).setScrollableContentRef;
    var _d = useState(false), isScrolled = _d[0], setScrolled = _d[1];
    var handleScroll = useCallback(function (scrollTop, distanceToBottom) {
        onScrolled && onScrolled(scrollTop, distanceToBottom);
        var scrolled = scrollTop > 0;
        if (isScrolled !== scrolled) {
            setScrolled(scrolled);
        }
    }, [onScrolled, isScrolled]);
    useEffect(function () {
        var contentNode = contentRef.current;
        if (!contentNode) {
            return;
        }
        if (contentNode.clientHeight === contentNode.scrollHeight) {
            onNotScrollable && onNotScrollable();
        }
    }, [children, onNotScrollable]);
    useOnScroll(contentRef, handleScroll, throttleTimeout, true);
    var setRef = function (node) {
        contentRef.current = node;
        setScrollableContentRef(node);
    };
    return (React.createElement("div", { className: classnames(s['root'], wrapperClassName) },
        React.createElement("div", { className: classnames(s['content'], className), ref: setRef },
            children,
            hasBackToTop && (React.createElement(SimpleBackToTop, { scrolled: isScrolled, getScrollableContainer: function () { return contentRef.current; }, className: backToTopClassName, forcedTheme: backToTopForcedTheme })))));
};
ScrollableContent.displayName = 'ScrollableContent';
export default ScrollableContent;
//# sourceMappingURL=ScrollableContent.experimental_body_scroll_lock.js.map